import { Entitlements } from '@protector/entities/licensing/constants';
import { getLicensingStatus } from 'core/core.selectors';
import { validatePlansAndEntitlements } from 'core/utils/functions';
import { getLoadingLicensingStatus } from 'entities/company/company.selectors';
import { buildTimelineFieldPath } from 'pages/timeline/field-details/field-details.paths';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { FlagGatedRoute } from './flag-gated-route.component';
import { lazyRoute } from './lazy-route';

const FieldDetailsPage = lazyRoute(() => import('pages/timeline/field-details/field-details.page'));

/*
 * Field Details only exists for contracts with the field progress view entitlement. Like the other
 * entitlement routes it waits for the licensing status, so a stale contract never decides, and sends
 * the reader back to the same field on the Timeline (P40-65031).
 */
const FieldDetailsEntitlementGate = () => {
  const { companyId = '', propertyId = '', fieldId = '' } = useParams();
  const licensingStatus = useSelector(getLicensingStatus);
  const isLoadingLicensingStatus = useSelector(getLoadingLicensingStatus);

  if (isLoadingLicensingStatus || !licensingStatus) {
    return null;
  }

  if (!validatePlansAndEntitlements(licensingStatus, null, [Entitlements.TIMELINE_FIELD_PROGRESS_VIEW])) {
    return <Navigate to={buildTimelineFieldPath(companyId, propertyId, fieldId)} replace />;
  }

  return <FieldDetailsPage />;
};

const FieldDetailsRoute = () => (
  <FlagGatedRoute flag='P40_64533_enable_field_details' testId='field-details'>
    <FieldDetailsEntitlementGate />
  </FlagGatedRoute>
);

export default FieldDetailsRoute;
